<template>
  <div class="numeric-entry-button-holder">{{ value }}</div>
</template>

<script>
export default {
  name: 'NumericEntryButton',
  props: [
    'value'
  ]
};
</script>

<style scoped>
.numeric-entry-button-holder {
  width: 33.3%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.numeric-entry-button-holder:hover {
  background-color: whitesmoke;
}
</style>